import React, { Component, ChangeEvent, Fragment } from "react";
import ErrorTip from "../errorTip";
import Attachment from "../attachment";
import add from "../../static/images/add.png";
import { arrReduce, getQueryString } from "../../utils/utils";
import { burying } from "../../utils/buryPoint";
import { getSign } from "../../services/services";
import { Progress, message } from "antd";
import styles from "./index.less";

interface Props {
  labelName: string;
  fieldName: string;
  is_required?: boolean;
  showTips?: string;
  maxSize?: number;
  errorTip?: string;
  reference?: boolean;
  modalType?: boolean;
  grayType?: boolean;
  source?:string;
  getValue?: (value: any, type: string) => void;
  onclick?: () => void;
  onblur?: () => void;
  onfocus?: () => void;
  changSubmitStatus?: (status: boolean) => void;
}

interface State {
  number: number;
  tipText: string;
  uploadStatus: boolean;
  progressStatus: boolean;
  progress: number;
  sign:string;
}

let baseArr: any[] = [];
let fileArr: any[] = [];
class UploadVoucher extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      number: 0, // 上传文件的数量
      tipText: "",
      uploadStatus: false,
      progressStatus: false,
      progress: 0,
      sign:""
    };
  }

  componentWillMount() {
    fileArr = [];
    baseArr = [];
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.modalType !== nextProps.modalType) {
      fileArr.splice(0, fileArr.length);
      baseArr.splice(0, baseArr.length);
    }
    if (nextProps.grayType) {
      this.setState({
        number: 0,
      });
      fileArr = [];
      baseArr = [];
    }
  }

  // 错误提示
  formatValidation = (text) => {
    this.setState({
      tipText: text,
    });
    return false;
  };

  // 上传按钮点击
  uploadChange = async (e: ChangeEvent<HTMLInputElement>) => {
    const { changSubmitStatus } = this.props;
    let files = e.target.files;
    let len = files.length;
    const file = files[0];
    const _this = this;
    const reg = /.\.(png|jpg|jpeg|mov|rar|zip|mp4|avi|pdf|doc|docx)$/i;
    const docreg = /.\.(rar|zip|pdf|doc|docx)$/i;
    const illegalReg = /[`~!@#_$%^&*()=|{}':;',\\\[\\\]<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？\s]/g;

    if (len > 0 && file.name) {
      const fileName =
        new Date().getTime() +
        file.name.toLocaleLowerCase().replace(illegalReg, "");

      if (!reg.test(fileName)) {
        this.formatValidation("不支持该格式的证据");
        return;
      }
      if (file.size >= 1024 * 1024 * 50) {
        this.formatValidation("上传的文件不能大于50M");
        return;
      }

      // 判断是否是附件上传
      if (!docreg.test(fileName)) {
        this.setState({
          uploadStatus: true,
        });
      } else {
        this.setState({
          progressStatus: true,
        });
      }
      changSubmitStatus(false);

      // 清空错误提示
      this.setState({
        tipText: "",
      });

      baseArr.push({
        attachmentName: file.name.toLocaleLowerCase().replace(illegalReg, ""),
        size: file.size / 1048576,
      });

      const appid = "bCdyXwVubChd";
      const wosurl = "//wos2.58.com";
      const bucket = "appealcenterfile";
      // const bucket ='transformtest';

      // const appid = "suqToNmLksTAu";
      // const wosurl = "//testv2.wos.58v5.cn";
      const ttl = 0; //文件过期时间，0为不设置，单位为小时，最小值168（7天）
      const insertOnly = 0; //insertOnly==0 表示允许覆盖文件 1表示不允许覆盖
      const alias = ""; //文件别名，默认不设置，如果设置，下载时通过http头中Content-Disposition字段返回
      const sliceSize = 1024 * 1024 * 4; //大文件上传的分片大小，默认1M，支持1,2,3,4M,小文件该字段为0，不受该值影响.
      //初始化逻辑
      const wos = new window.WosSys({
        appid: appid, // APPID 必填参数
        bucket: bucket, //bucketName 必填参数
        wosurl: wosurl, //wos的url 必填参数
        getAppSign: async function(callback: any) {
          //获取签名 必填参数
          //搭建一个业务自己的鉴权服务器，做业务相关的鉴权，例如校验登录态等，校验通过后请求WOS的TokenServer获取签名
          const params = {
            filename: fileName,
          };
          const tokenData = await getSign(params); //鉴权请求
          if (tokenData && tokenData.code === 0) {
            const sig = tokenData.data;
            _this.setState({sign:tokenData.data})
            callback(encodeURIComponent(sig));
          } else {
            _this.setState({
              uploadStatus: false,
              progressStatus: false,
            });
            message.info("上传失败");
          }
        },
      });
      wos.uploadFile(
        this.succCB,
        this.errCB,
        this.progCB,
        bucket,
        fileName,
        file,
        ttl,
        insertOnly,
        this.taskReady,
        sliceSize,
        alias
      );
    }
  };

  //type 1,2,3   图片、视频、文件
  succCB = async (result: any) => {
    const { getValue, fieldName, changSubmitStatus } = this.props;
    const rel = JSON.parse(result);
    let regPic = /(png|jpg|jpeg)/gi;
    let regVideo = /(mov|mp4|avi)/gi;
    let regfile = /(rar|doc|pdf|zip)/gi;
    let that = this;
    if (rel.code === 0) {
      const url = rel.data.access_url;
      baseArr.forEach((item: any) => {
        if (url.indexOf(item.attachmentName) !== -1) {
          if (regPic.test(item.attachmentName)) {
            fileArr.push({
              fileType: 1,
              showUrl:`${url}?token=${that.state.sign}`,
              attachmentPath: url,
              fieldName: fieldName,
              ...item,
            });
          }
          if (regVideo.test(item.attachmentName)) {
            fileArr.push({
              fileType: 2,
              showUrl:`${url}?token=${that.state.sign}`,
              attachmentPath: url,
              fieldName: fieldName,
              ...item,
            });
          }
          if (regfile.test(item.attachmentName)) {
            fileArr.push({
              fileType: 3,
              showUrl:`${url}?token=${that.state.sign}`,
              attachmentPath: url,
              fieldName: fieldName,
              ...item,
            });
          }
        }
      });
      await this.setState({
        number: this.state.number + 1,
        uploadStatus: false,
        progressStatus: false,
      });
      //改变提交按钮状态
      changSubmitStatus(true);
      //去重
      fileArr = arrReduce(fileArr, "attachmentPath");
      getValue(
        fileArr.filter((item) => {
          return item.fieldName === fieldName;
        }),
        fieldName
      );
    }
  };
  errCB = (result: any) => {
    this.setState({
      uploadStatus: false,
      progressStatus: false,
    });
    message.info("上传失败");
  };

  progCB = (curr: any) => {
    // const process = curr === 1 ? 0 : curr;
    this.setState({
      progress: curr * 100,
    });
  };

  taskReady = (taskId: any) => {
    console.log("taskId", taskId);
  };

  /**
   * @description 上传按钮
   *
   **/
  renderUploadButton = () => {
    const { number, uploadStatus, progressStatus } = this.state;
    const { maxSize, grayType,source } = this.props;
    const punishId = getQueryString("punishId");
    if (number < maxSize) {
      return (
        <div
          className={styles.uploadButton}
          onClick={() => {
            source==="bounced"?burying(
              "2",
              "write-appeal-add",
              `frame=1$punishid=${punishId}`,
              "ss-05",
              "undefined"
            ):burying(
              "2",
              "write-appeal-submit",
              `frame=1$punishid=${punishId}`,
              "ss-03",
              "undefined"
            );
          }}
        >
          <img src={add} />
          <span className={styles.add}>点击上传</span>
          <input
            type="file"
            onChange={this.uploadChange}
            disabled={grayType || uploadStatus || progressStatus}
          />
        </div>
      );
    } else return null;
  };

  /**
   * @description 附件删除
   *
   **/
  deleteDocument = (attachmentPath: string, field: string) => {
    const { getValue, fieldName } = this.props;
    fileArr.forEach((item: any, index: number) => {
      if (item.attachmentPath === attachmentPath && item.fieldName === field) {
        fileArr.splice(index, 1);
        baseArr.splice(index, 1);
      }
    });
    this.setState({
      number: this.state.number - 1,
    });
    getValue(
      fileArr.filter((item) => {
        return item.fieldName === fieldName;
      }),
      fieldName
    );
  };

  /**
   * @description 视频、图片
   *
   **/
  renderSquareModel = () => {
    const { fieldName, grayType } = this.props;
    return fileArr
      .filter((item) => {
        return item.fieldName === fieldName;
      })
      .map((item: any, index: number) => {
        switch (item.fileType) {
          case 1:
            return (
              <Fragment key={index}>
                <Attachment
                  showUrl={item.showUrl}
                  name={item.attachmentName}
                  type={item.fileType}
                  deleteDocument={this.deleteDocument}
                  path={item.attachmentPath}
                  fieldName={fieldName}
                  grayType={grayType}
                />
              </Fragment>
            );
          case 2:
            return (
              <Fragment key={index}>
                <Attachment
                  showUrl={item.showUrl}
                  name={item.attachmentName}
                  type={item.fileType}
                  deleteDocument={this.deleteDocument}
                  path={item.attachmentPath}
                  fieldName={fieldName}
                  grayType={grayType}
                />
              </Fragment>
            );
          default:
            return null;
        }
      });
  };

  /**
   * @description 上传中状态
   *
   **/
  renderUploadStauts = () => {
    const { uploadStatus } = this.state;
    return uploadStatus ? (
      <div className={styles.room_img}>
        <p className={styles.loading}>
          <i className={styles.load_icon} />
          上传中...
        </p>
      </div>
    ) : null;
  };

  renderDocumentStatus = () => {
    const { progressStatus, progress } = this.state;
    return progressStatus ? (
      <Progress
        percent={progress}
        showInfo={false}
        status="active"
        strokeColor={"#FF552E"}
      />
    ) : null;
  };

  /**
   * @description 文件
   *
   **/
  renderDocumentModel = () => {
    const { fieldName, grayType } = this.props;
    return fileArr
      .filter((item) => {
        return item.fieldName === fieldName;
      })
      .map((item: any, index: number) => {
        switch (item.fileType) {
          case 3:
            return (
              <Fragment key={index}>
                <Attachment
                  name={item.attachmentName}
                  path={item.attachmentPath}
                  showUrl={item.showUrl}
                  size={item.size.toFixed(3)}
                  type={item.fileType}
                  deleteDocument={this.deleteDocument}
                  fieldName={fieldName}
                  grayType={grayType}
                />
              </Fragment>
            );
          default:
            return null;
        }
      });
  };

  render() {
    const {
      labelName,
      is_required,
      maxSize,
      errorTip,
      showTips,
      reference,
    } = this.props;
    const { number, tipText, uploadStatus, progressStatus } = this.state;
    return (
      <div className={styles.uploadVoucher}>
        <div className={styles.title}>
          <span className={styles.labelName}>
            {is_required ? <span className={styles.star}>*</span> : null}
            {labelName ? labelName : "上传凭证"}：
          </span>
          <span className={styles.textMessage}>{showTips}</span>
        </div>
        <div className={styles.uploadContent}>
          <div className={styles.upload}>
            <div className={styles.renderSquareModel}>
              {this.renderUploadButton()}
              {this.renderSquareModel()}
              {this.renderUploadStauts()}
            </div>
            {this.renderDocumentModel()}
            {this.renderDocumentStatus()}
          </div>
          {uploadStatus || progressStatus ? null : (
            <div className={styles.errorTip}>
              {errorTip.length && number === 0 && is_required ? (
                <ErrorTip errorTip={errorTip} />
              ) : tipText ? (
                <ErrorTip errorTip={tipText} />
              ) : null}
            </div>
          )}
          <div
            className={styles.showTips}
            style={{ marginTop: !reference ? "15px" : "" }}
          >
            <div className={styles.maxSize}>
              {number}/{maxSize}
            </div>
            <div className={styles.tips}>
              {reference
                ? null
                : "注：支持png、jpg、jpeg、mp4、mov、avi、doc、docx，pdf、rar、zip格式，每个文件不能大于50M"}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default UploadVoucher;
